<template>
  <div class="klickbox-edit-code" v-if="step.kind === 'multiple-choice'">
    <div class="kp-modular-row clearfix">
      <label class="kp-modular-label label__checkbox">{{ $t('edit.canvas.multiple_answers') }}</label>
      <div class="kp-modular-check pull-right kp-modular-check-without-icon">
        <input type="checkbox" @change="stepUpdateMultipleAnswers({ event: $event, id: step.id })" v-bind:checked="step.multiple_answers"><span></span>
      </div>
    </div>
    <div class="kp-modular-row clearfix">
      <label class="kp-modular-label label__checkbox">{{ $t('edit.canvas.add_other_option') }}</label>
      <div class="kp-modular-check pull-right kp-modular-check-without-icon">
        <input type="checkbox" @change="optionUpdateOtherAnswer({ event: $event })" v-bind:checked="optionOtherAnswer"><span></span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  computed: mapGetters({
    step: 'stepActive',
    optionOtherAnswer: 'optionOtherAnswer',
    options: 'optionList',
  }),
  methods: mapActions([
    'stepUpdateMultipleAnswers',
    'optionUpdateOtherAnswer',
  ]),
};
</script>



/** WEBPACK FOOTER **
 ** MultipleChoice.vue?799c9738
 **/